<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Order Deduction No: {{ formData.orderDeductionNo || 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.orderDeductionStatus === 'Y'
              ? 'success'
              : formData.orderDeductionStatus === 'S'
              ? 'warning'
              : formData.orderDeductionStatus === 'D' ||
                formData.orderDeductionStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_orderDeductionStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update: {{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_salesPersonCode') || '业务人员'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              :selectedLabel.sync="formData.salesPersonName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_a_business_person') ||
                  '请选择业务人员'
              "
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_requestDate') || '申请日期'"
            prop="requestDate"
          >
            <el-date-picker
              v-model="formData.requestDate"
              :picker-options="requestDateEndOpt"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_deductionMethod') || '扣款方式'"
            prop="deductionMethod"
          >
            <dict-select
              v-model="formData.deductionMethod"
              url="/master/common/dict/biz"
              :body="deductionMethodParams"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_deductionCustName') || '扣款客户'"
            prop="deductionCustCode"
          >
            <dict-select
              v-model="formData.deductionCustCode"
              url="/digitalCenter/common/dict/customer"
              clearable
              size="mini"
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_scmDeductionMethod') || '供应商扣款方式'"
            prop="scmDeductionMethod"
          >
            <dict-select
              v-model="formData.scmDeductionMethod"
              url="/master/common/dict/biz"
              :body="deductionMethodParams"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_expensePayer') || '申请公司'">
            <dict-select
              v-model="formData.expensePayerCode"
              :body="expensePayerParams"
              :selectedLabel.sync="formData.expensePayerName"
              url="/master/common/dict/biz"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item :label="$l('form_label_currencyAmount') || '费用合计'">
            <el-input v-model="v_currencyAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              :body="currencyUnitParams"
              url="/master/common/dict/biz"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_scmCurrencyAmount') || '供应商费用合计'"
          >
            <el-input v-model="v_scmCurrencyAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_scmCurrencyUnit') || '供应商货币单位'"
            prop="scmCurrencyUnit"
          >
            <dict-select
              v-model="formData.scmCurrencyUnit"
              :body="currencyUnitParams"
              url="/master/common/dict/biz"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_remark') || '付款用途'"
            prop="remark"
          >
            <el-input
              v-model="formData.remark"
              maxlength="200"
              size="mini"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_description') || '付款说明（不打印）'"
          >
            <el-input
              v-model="formData.description"
              type="textarea"
              :rows="5"
              maxlength="300"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_notes') || '备注'">
            <el-input
              v-model="formData.notes"
              type="textarea"
              :rows="5"
              maxlength="300"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <ItemTable
          ref="itemTable"
          :disabled="disabled"
          :orderDeductionCode="orderDeductionCode"
          @updateTotAmount="(e) => (formData.currencyAmount = e)"
          @updateScmTotAmount="(e) => (formData.scmCurrencyAmount = e)"
          :depCode="salesPersonInfo.depCode"
          :orgDepFullName="salesPersonInfo.orgDepFullName"
        />
      </el-row>
      <el-row>
        <DocTable
          ref="docTable"
          :disabled="disabled"
          :orderDeductionCode="orderDeductionCode"
        />
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
import DocTable from '../doc-table'
import dayjs from 'dayjs'
export default {
  components: { ItemTable, DocTable },
  mixins: [EditLoading],
  props: {
    orderDeductionCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      currencyUnitParams: { dictType: 'bankAccountKind' },
      expensePayerParams: { dictType: 'expensePayer' },
      deductionMethodParams: { dictType: 'deductionMethod' },
      requestDateEndOpt: this.requestDateEnd(),
      formData: {
        oaDeductionProcess: 'A',
        salesPersonCode: '',
        salesPersonName: '',
        deductionCustCode: '',
        currencyAmount: 0,
        scmCurrencyAmount: 0,
        remark: '',
        description: '',
        notes: '',
        requestDate: dayjs(new Date()).format('YYYY-MM-DD'),
      },
      rules: {
        salesPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],

        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],

        remark: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
      },
      salesPersonInfo: {},
    }
  },
  computed: {
    v_currencyAmount() {
      const { currencyAmount } = this.formData
      return !currencyAmount ? '0' : currencyAmount.toLocaleString()
    },
    v_scmCurrencyAmount() {
      const { scmCurrencyAmount } = this.formData
      return !scmCurrencyAmount ? '0' : scmCurrencyAmount.toLocaleString()
    },
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.orderDeductionCode) return
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.salesPersonCode = userCode || ''
        this.formData.salesPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
    // 查询业务人员详情，主要取部门信息作为费用明细的默认分摊部门
    'formData.salesPersonCode': {
      async handler(userCode) {
        if (!userCode) return

        const res = await this.$api.sysUserDetailApi({ userCode })
        if (!res) return
        this.salesPersonInfo = res.body || {}
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    // 申请日期限制
    requestDateEnd() {
      return {
        disabledDate(time) {
          //如果结束时间不为空，则小于结束时间
          return new Date().getTime() < time.getTime()
        },
      }
    },
    reload() {
      this.getData()
      this.$refs.itemTable.loadData()
      this.$refs.docTable.loadData()
    },
    getData() {
      if (!this.orderDeductionCode) return
      this.$api
        .orderDeductionDetailApi({
          orderDeductionCode: this.orderDeductionCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await this.formValidate()
      if (!result) return

      const listItem = this.$refs.itemTable.getTableData()
      if (!listItem || listItem.length < 1) {
        this.$message.warning(
          this.$l('tips_please_add_expense_item') || '请添加费用填报明细'
        )
        return
      }
      const listDoc = this.$refs.docTable.getTableData()

      this.loadingOpen()
      this.$api
        .orderDeductionSaveApi({ ...this.formData, listItem, listDoc })
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.orderDeductionCode) {
            this.closeCurPage()
          } else {
            this.reload()
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const itemTableResult = await this.$refs.itemTable.validate()
      return formResult && itemTableResult
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },

    async getCustData(form) {
      return await this.$api
        .masterCustomerBankListApi(form)
        .then((res) => res.body.data)
        .catch(() => null)
    },
    async getScmData(form) {
      return await this.$api
        .masterScmInfoBankListApi(form)
        .then((res) => res.body.data)
        .catch(() => null)
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
